import { render, staticRenderFns } from "./thirdTestSite.vue?vue&type=template&id=fa1fa904&scoped=true&"
import script from "./thirdTestSite.vue?vue&type=script&lang=js&"
export * from "./thirdTestSite.vue?vue&type=script&lang=js&"
import style0 from "./thirdTestSite.vue?vue&type=style&index=0&id=fa1fa904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1fa904",
  null
  
)

export default component.exports